import React, { useEffect, useRef, useState } from "react";
import { FaTimes } from "react-icons/fa";

const RejectReasonModal = ({ title, description, confirmLabel = "Reject", onClose, onSubmit }) => {
    const modalRef = useRef(null);
    const bsModalRef = useRef(null);
    const [reason, setReason] = useState("");
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        const el = modalRef.current;
        if (!el || !window.bootstrap) return undefined;
        const instance = window.bootstrap.Modal.getOrCreateInstance(el);
        bsModalRef.current = instance;
        const handleHidden = () => onClose?.();
        el.addEventListener("hidden.bs.modal", handleHidden);
        instance.show();
        return () => {
            el.removeEventListener("hidden.bs.modal", handleHidden);
            instance.hide();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmit = async () => {
        const trimmed = reason.trim();
        if (!trimmed) return;
        setSubmitting(true);
        await onSubmit?.(trimmed);
        setSubmitting(false);
    };

    return (
        <div className="modal fade" tabIndex="-1" ref={modalRef} aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content kyc-verify-modal">
                    <div className="modal-body p-0">
                        <div className="kyc-verify-modal-title">
                            <span>{title || "Provide a reason"}</span>
                            <button type="button" className="kyc-verify-modal-close" data-bs-dismiss="modal" aria-label="Close" disabled={submitting}>
                                <FaTimes />
                            </button>
                        </div>
                        <div className="kyc-verify-modal-subtitle">
                            {description || "Let the customer know why this is being rejected."}
                        </div>
                        <div className="kyc-verify-modal-body">
                            <label className="form-label small">Reason</label>
                            <textarea
                                className="form-control"
                                rows={3}
                                autoFocus
                                value={reason}
                                onChange={(e) => setReason(e.target.value)}
                                placeholder="Explain why this is being rejected..."
                                disabled={submitting}
                            />
                            <div className="d-flex justify-content-end gap-2 mt-3">
                                <button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal" disabled={submitting}>Cancel</button>
                                <button type="button" className="btn btn-danger" onClick={handleSubmit} disabled={submitting || !reason.trim()}>
                                    {submitting ? "Submitting..." : confirmLabel}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RejectReasonModal;
